import * as actionTypes from '../actions/commands/actionTypes';

const initialState = {
    pendingCounter: 0,
    activeCounter: 0,
    failedCounter: 0,
    completedCounter: 0,
};

const commandsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.REFRESH_COUNTERS: {
            const { pendingCounter, activeCounter, failedCounter, completedCounter } = action.payload.counters;

            return { ...state, pendingCounter, activeCounter, failedCounter, completedCounter };
        }

        default:
            return state;
    }
}

export default commandsReducer;
